(function () {
  'use strict';
  if (window.raDetailExpandedGallery) { window.raDetailExpandedGallery(document); return; }
  function init(scope) {
    scope.querySelectorAll('[data-ra-detail-compact] [data-ra-carousel]').forEach(function (gallery) {
      gallery.dataset.carouselReady = 'expanded';
      gallery.setAttribute('role', 'group');
      gallery.removeAttribute('aria-roledescription');
      gallery.querySelectorAll('.ra-detail-controls,.ra-detail-guide-tabs').forEach(function (control) { control.remove(); });
      var track = gallery.querySelector('[data-ra-track]');
      if (!track) return;
      track.removeAttribute('tabindex');
      Array.from(track.children).forEach(function (slide) {
        slide.inert = false;
        slide.removeAttribute('aria-hidden');
        slide.removeAttribute('aria-roledescription');
        slide.removeAttribute('aria-label');
      });
    });
  }
  window.raDetailExpandedGallery = init;
  window.raDetailCompact = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());

/* Match desktop detail content to the visible top-level navigation content. */
(function () {
  'use strict';
  if (window.raDetailNavTextWidth) { window.raDetailNavTextWidth(); return; }
  var pending = false;
  var observedNav = null;
  var resizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;
  var mutationObserver = window.MutationObserver ? new MutationObserver(schedule) : null;
  function watch(nav) {
    if (nav === observedNav) return;
    if (resizeObserver) resizeObserver.disconnect();
    if (mutationObserver) mutationObserver.disconnect();
    observedNav = nav;
    if (!nav) return;
    if (resizeObserver) resizeObserver.observe(nav);
    if (mutationObserver) mutationObserver.observe(document.querySelector('#SiteHeader') || nav, {childList:true,characterData:true,subtree:true,attributes:true,attributeFilter:['class','style','hidden','aria-hidden']});
  }
  function update() {
    pending = false;
    var roots = document.querySelectorAll('[data-ra-detail-compact]');
    if (!roots.length) return;
    if (!window.matchMedia('(min-width:769px)').matches) {
      roots.forEach(function (root) {
        if (root.style.getPropertyValue('--ra-detail-nav-text-width')) root.style.removeProperty('--ra-detail-nav-text-width');
      });
      return;
    }
    var nav = document.querySelector('#SiteHeader .site-navigation');
    watch(nav);
    if (!nav || !nav.getBoundingClientRect().width) return;
    var left = Infinity;
    var right = -Infinity;
    Array.from(nav.children).forEach(function (item) {
      var link = item.querySelector('.site-nav__link');
      if (!link) return;
      var box = link.getBoundingClientRect();
      var style = window.getComputedStyle(link);
      if (!box.width || !box.height || style.display === 'none' || style.visibility === 'hidden') return;
      var range = document.createRange();
      range.selectNodeContents(link);
      var content = range.getBoundingClientRect();
      if (!content.width || !content.height) return;
      left = Math.min(left, content.left);
      right = Math.max(right, content.right);
    });
    if (!Number.isFinite(left) || !Number.isFinite(right) || right <= left) return;
    var value = (Math.round((right - left) * 1000) / 1000) + 'px';
    roots.forEach(function (root) {
      if (root.style.getPropertyValue('--ra-detail-nav-text-width') !== value) root.style.setProperty('--ra-detail-nav-text-width', value);
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(update);
  }
  window.raDetailNavTextWidth = schedule;
  window.addEventListener('resize', schedule, {passive:true});
  document.addEventListener('shopify:section:load', schedule);
  if (document.fonts) {
    document.fonts.ready.then(schedule);
    if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true});
  else schedule();
}());
